import { http } from "./http";

export type CarelDiagDisplayCase = {
  displayCase: number;
  temperature: number | null;
  setpoint: number | null;
  probes: Array<{ name: string; value: string; description: string }>;
};

export type CarelDiagAlarm = {
  id: string | null;
  name: string;
  value: string;
  description: string;
};

export type CarelDiagOther = {
  name: string;
  value: string;
  description: string;
  kind: string;
};

export type CarelDiagVariable = {
  name: string;
  id: string;
  desc: string;
  type: string;
  access: string;
  val: string;
};

export type CarelDiagResponse = {
  machineId: string;
  machineName: string;
  fetchedAt: string;
  displayCases: CarelDiagDisplayCase[];
  alarms: CarelDiagAlarm[];
  other: CarelDiagOther[];
  allVariables?: CarelDiagVariable[];
};

export async function getCarelDiag(
  token: string | null,
  machineId: string
): Promise<CarelDiagResponse> {
  return http<CarelDiagResponse>(
    `/carel/machines/${encodeURIComponent(machineId)}/diag`,
    { method: "GET" },
    token
  );
}
